import classnames from 'classnames';
import React, { FC, useCallback, useEffect, useState } from 'react';
import ProgressArc from 'react-progress-arc';
import { audio, useAudioPlayback } from '../../../../../utils/hooks/useAudioPlayback';
import { WixIcons } from '../../../../common';
import { IOuter } from '../../../Gallery/GalleryFile/GalleryFileControls/GalleryFileControls.types';
import styles from './MusicControls.scss';

export const MusicControls: FC<IOuter> = ({ size = 'normal', buttonClassName, file }) => {
  const { playTrack, stopTrack, isPlaying } = useAudioPlayback(file);

  const [playingProgress, setPlayingProgress] = useState(0);
  const setProgressFromAudio = useCallback(() => setPlayingProgress(audio.currentTime / audio.duration || 0), []);

  useEffect(() => {
    if (isPlaying) {
      audio.addEventListener('timeupdate', setProgressFromAudio, true);
    } else {
      audio.removeEventListener('timeupdate', setProgressFromAudio, true);
    }

    return () => {
      audio.removeEventListener('timeupdate', setProgressFromAudio, true);
    };
  }, [isPlaying, setProgressFromAudio]);

  const isSmall = size === 'small';
  const buttonSize = isSmall ? parseInt(styles.playButtonSmallSize, 10) : parseInt(styles.playButtonSize, 10);

  const ControlButtonIcon = isPlaying ? WixIcons.PauseFilled : WixIcons.PlayFilled;

  const handleTogglePlay = useCallback(() => {
    isPlaying ? stopTrack() : playTrack(file);
  }, [isPlaying, stopTrack, playTrack, file]);

  return (
    <div
      className={classnames(styles.musicPlayButtonWrapper, {
        [styles.isPlaying]: isPlaying,
      })}
    >
      <div
        className={classnames(isSmall ? styles.musicPlayButtonSmall : styles.musicPlayButton, buttonClassName)}
        onClick={handleTogglePlay}
        data-hook="music-play-button"
      >
        <ControlButtonIcon />

        {isPlaying && (
          <div className={styles.progressWrapper}>
            <ProgressArc
              className={styles.progressArc}
              completed={playingProgress}
              diameter={buttonSize}
              strokeWidth={2}
            />
          </div>
        )}
      </div>
    </div>
  );
};
